import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  totalCountText: {
    '&&': {
      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.up('laptop_l')]: {
        marginBottom: SPACES.s,
      },
    },
  },
}))

export { useStyles }
